module.exports = __webpack_public_path__ + "static/img/mpdpImgTwo2.268191a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mpdpImgTwo2.png
// module id = Wvmt
// module chunks = 2